import React from "react";
import { useTranslation } from "react-i18next";
import { VelavuInvoiceUsage } from "velavu-js-api";
import { formatBillingPrice } from "./settings-billing-format";
import * as styles from "./settings-billing-usage-table.module.scss";
import { VelavuRoundTable } from "../../../elements/velavu-round-table";

export interface SettingsBillingUsageTableProps {
	usage: VelavuInvoiceUsage[];
}

function InvoiceUsageRow(props: { usage: VelavuInvoiceUsage }) {
	return (
		<tr>
			<td className={styles.productLabel}>{props.usage.product}</td>
			<td>{props.usage.quantity}</td>
			<td>{formatBillingPrice(props.usage.unit_price)}</td>
			<td>
				<span className={styles.lineTotal}>
					{formatBillingPrice(props.usage.line_total)}
				</span>
			</td>
		</tr>
	);
}

function stringifyUsage(usage: VelavuInvoiceUsage) {
	return `${usage.product}-${usage.quantity}`;
}

export default function SettingsBillingUsageTable(
	props: SettingsBillingUsageTableProps,
) {
	const { t } = useTranslation();

	return (
		<VelavuRoundTable
			layout={[
				{ flex: 8 },
				{ flex: 3, alignment: "center" },
				{ flex: 4, alignment: "center" },
				{ width: 90, alignment: "end" },
			]}
		>
			<thead>
				<tr>
					<th>{t("common.product")}</th>
					<th>{t("common.quantity")}</th>
					<th>{t("settings.billing.monthly_rate")}</th>
					<th>{t("settings.billing.line_total")}</th>
				</tr>
			</thead>
			<tbody>
				{props.usage.map((usage, idx) => (
					<InvoiceUsageRow
						key={`${idx}-${stringifyUsage(usage)}`}
						usage={usage}
					/>
				))}
			</tbody>
		</VelavuRoundTable>
	);
}
